var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.085 11.004a.655.655 0 01-.394.295.655.655 0 01-.488-.058L.77 8.782a.913.913 0 01-.342-1.277l.326-.544a.993.993 0 011.323-.355l2.768 1.535L9.248.81A.993.993 0 0110.57.456l.555.308c.46.255.613.827.342 1.278l-5.383 8.962z",
    fill: "#ED1B2E"
  })));
}

export default SvgCheck;